<template>
  <div class="view-container">
    <div>
      <TextComponent fieldName="Name" v-model="items.idMwc" />
      <div class="mwc-content">
        <p>MWC Content</p>
        <div class="mwc-set">
          <ul type="none" @click="selectedElement">
            <li
              v-for="(item, index) in items.slides"
              :key="index"
              draggable
              @dragstart="startDrag($event, index)"
              @drop="onDrop($event, index)"
              @dragover.prevent
              @dragenter.prevent>
              <MwcComponent
                class="mwc"
                :item="item"
                :index="index"
                :selectedIndex="selectedIndex"
                @changeValue="changeValue"
                @selectedValue="selectedElement" />
            </li>
          </ul>
        </div>
        <div class="bottom button-group">
          <div>
            <button class="btn" @click="publishMwc">Publish</button>
            <button class="btn primary" @click="showConfirmDialog">Save</button>
          </div>
          <div>
            <button
              class="btn warning"
              @click="removeMwcSlide"
              :disabled="selectedIndex == -1">
              Remove
            </button>
            <button class="btn" @click="addMwcSlide">Add</button>
          </div>
        </div>
      </div>
    </div>
    <div class="mwc-carousel">
      <MWCCarouselViewVue :isPreview="true" :previewSlides="items.slides" :mwcName="items.idMwc" />
    </div>
    <ConfirmationComponent :isOpen="isOpen" confirmName="Save" @confirm="save">
      <div slot="header">Save {{ items.idMwc }}</div>
      <div slot="content">Are you sure you want to save {{ items.idMwc }}?</div>
    </ConfirmationComponent>
  </div>
</template>

<script>
import TextComponent from '../base.component/TextComponent.vue';
import MwcComponent from './MwcComponent.vue';
import FileUploadComponent from '../base.component/FileUploadComponent.vue';
import MWCCarouselViewVue from '@/views/MWCCarouselView.vue';
import AssetsMwcApiService from '@/services/assetsMwcServices/assetsMwcApiService';
import AssetsMwcService from '@/services/assetsMwcServices/assetsMwcService';
import ConfirmationComponent from '../base.component/ConfirmationComponent.vue';

export default {
  components: {
    TextComponent,
    MwcComponent,
    FileUploadComponent,
    MWCCarouselViewVue,
    ConfirmationComponent
  },

  data() {
    return {
      items: [],
      selectedIndex: -1,
      setName: '',
      files: '',
      assets: new Object(),
      isOpen: false
    };
  },

  created() {
    this.items = AssetsMwcService.getAssetsMwc();
  },

  methods: {
    addMwcSlide() {
      this.items.slides.push('');
    },

    selectedElement(index) {
      if (typeof index == 'number') {
        this.selectedIndex = this.selectedIndex == index ? -1 : index;
      }
    },

    startDrag(event, index) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('itemID', index);
    },

    onDrop(event, index) {
      const prevIndex = event.dataTransfer.getData('itemID');
      const move = (from, to, ...arr) =>
        from === to ? arr : (arr.splice(to, 0, ...arr.splice(from, 1)), arr);

      this.items.slides = move(prevIndex, index, ...this.items.slides);
    },

    removeMwcSlide() {
      if (this.selectedIndex != -1) {
        this.items.slides.splice(this.selectedIndex, 1);
        this.selectedIndex = -1;
      }
    },

    async save() {
      const digit = this.items.idMwc?.match(/\d+/) ?? 0;
      this.items.year = digit[0];
      const assetsMwc = {
        model: this.items,
        files: this.assets
      };

      await AssetsMwcApiService.createAssetsMwc(assetsMwc);
      await AssetsMwcApiService.getAssetsMwc();
      this.items = AssetsMwcService.getAssetsMwc();
    },

    changeValue(name, file) {
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.onload = () => {
        this.assets[name] = fr.result;
      };
      fr.onerror = () => console.error(fr.error);
      this.items.slides[this.items.slides.length - 1] = name;
    },

    showConfirmDialog() {
      this.isOpen = !this.isOpen;
    },

    async publishMwc() {
      await AssetsMwcApiService.publishMwc();
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';
@import '~@eds/vanilla/variables/dark.less';

.view-container {
  display: flex;
  overflow: scroll;
  padding-top: 1rem;
  min-width: 80vw;
  //   padding: @space-base @space-large;
}

.mwc-content {
  padding-top: 1rem;
}

.mwc-set {
  border: 1px solid @gray-42;
  margin-top: 0.25rem;
}

.mwc {
  margin: 0.5rem;
}

.bottom {
  padding-top: 1rem;
  text-align: end;
}

.mwc-carousel {
  margin-left: 1rem;
  min-width: 65vw;
  min-height: 90vh;
}

.button-group {
  display: flex;
  justify-content: space-between;
}
</style>
